import ssc from './ssc';
import hpten from './hpten';
// import pk10 from './pk10';
import ks from './ks';
export default (type, data, Vue) => {
  if (type == 'ssc') {
    return ssc(data);
  }
  if (type == 'hpten') {
    return hpten(data);
  }
  // if (type == 'PK10' || type == 'nn') {
  //   return pk10(data);
  // }
  if (type == 'ks') {
    return ks(data);
  }
};



// WEBPACK FOOTER //
// ./src/pages/Trend/Lishihaomatongji/columns/index.js